import { render, staticRenderFns } from "./ProductViewGlobal.vue?vue&type=template&id=fde6c6ce"
import script from "./ProductViewGlobal.vue?vue&type=script&lang=js"
export * from "./ProductViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports